import validator from "validator";
import { toast } from "react-toastify";
import moment from 'moment';
import 'moment/locale/he';
import { PhoneNumberUtil } from "google-libphonenumber";


const phoneUtil = PhoneNumberUtil.getInstance();

export const checkEmailFormate = (value) => {
  if (value) {
    return validator.isEmail(value);
  }
};

export function handleCopyToClipboard(value, type, t ) {
  navigator.clipboard.writeText(value);

  let toastMessage = t("copied");
  let toastId = null;

  switch (type) {
    case "doctor":
      toastMessage = t("Doctor's link copied");
      toastId = "doctor-toast";
      break;
    case "client":
      toastMessage = t("Client's link copied");
      toastId = "client-toast";
      break;
    case "guest":
      toastMessage = t("Guest's link copied");
      toastId = "guest-toast";
      break;
    case "zoom":
      toastMessage = "Password copied";
      toastId = "zoom-toast";
      break;
    default:
      toastMessage = "copied";
      toastId = "default-toast";
      break;
  }

  if (!toast.isActive(toastId)) {
    toast.success(toastMessage, { toastId });
  }
}

export const formatDate = (date) => {
  return moment(date).format('DD/MM/YY HH:mm');
};

export const debounce = (callback, delay) => {
  let timeout;

  return (...args) => {
    // Clear the existing timeout
    if (timeout) {
      clearTimeout(timeout);
    }

    // Set a new timeout
    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};


export function validateIsraeliID(id) {
	id = String(id).trim();
	if (id.length > 9 || isNaN(id)) return false;
	id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
		return Array.from(id, Number).reduce((counter, digit, i) => {
			const step = digit * ((i % 2) + 1);
			return counter + (step > 9 ? step - 9 : step);
		}) % 10 === 0;
}

export const isMobile = () => {
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return isTouchDevice || isMobileUA;
};

// Function to format the ISO date to  the browser locale.
export const formattedDate = (isoDate) => {
  const date = moment(isoDate);

  if (!date.isValid()) {
    return 'תאריך לא חוקי'; // "Invalid date" in Hebrew
  }

  return date.locale('he').format('L'); // Localized short date format
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const countHashes = (str = "") =>
  (str.match(/#/g) || []).length;

export const validateMobile = (mobile, t) => {
  if (!mobile) {
    return t("Please enter mobile number");
  }

  if (mobile.length > 20) {
    return t("Mobile number max length 20");
  }

  if (!mobile.startsWith("05") && !mobile.startsWith("+")) {
    return t("Phone number must start with 05 or +.");
  }

  try {
    const parsedNumber = phoneUtil.parse(mobile, "IL");
    if (!phoneUtil.isValidNumber(parsedNumber)) {
      return t("Invalid phone number.");
    }
  } catch (err) {
    return t("Invalid phone number.");
  }

  return ""; // valid → no error
};